import React from 'react';
import PropTypes from 'prop-types';

import DataTableVirtualized from 'components/DataTableVirtualized';
import DataTablePaginated from 'components/DataTablePaginated';

const DataTable = (props) => {
  const {
    virtualized = false,
  } = props;

  if (virtualized) {
    return <DataTableVirtualized {...props} />;
  } else {
    return <DataTablePaginated {...props} />;
  }
};

DataTable.propTypes = {
  virtualized: PropTypes.bool,
};

export default DataTable;
